<template>
<div class="row">
	<div class="col-sm-12 col-md-12 py-5">
		<h1 class="display-4"> ABOUT US </h1>
	</div>
	<div id="html-body" class="">
		<div style="width: 100%" v-html="html"></div>
	</div>
</div>
</template>

<script>
    export default {
        mounted() {
            console.log('Component mounted.');
			//this.getUser(); 
			this.getInfoPage();
        },
		
		props: {

		},

		data () {
			return {
				html: '<p>No info data found!!!</p>'
			}
		},
		created () {
		
		},

		computed: {
			isLogged() { 
				return this.$store.state.options.islogged;
			}
		},

		watch: {
			
		},
		methods: {
			getInfoPage() {
				this.$store.commit('serviceLoading');
				let form = new FormData();
                form.append('pageid', 1);
				axios.post('/api/getinfopage', form, {
                    headers: {
                      'Content-Type': 'multipart/form-data'
                    }
                }).then(response => {
					this.$store.commit('serviceFinished');
					console.log(response.data);
					this.html = response.data;
				}).catch(error => {
					this.$store.commit('serviceFinished');
					console.log(error);
				});
			}
		},
		components: {
			
		}
    }
</script>

<style>
#html-body{width: 100%;}
</style>

